module.exports = __webpack_public_path__ + "static/media/logo.17a8a727.svg";